define(
  'Header.View.Extension',
  [
    'Header.View',
    'underscore'
  ],
  function (
    HeaderView,
    _
  ) {
    'use strict';

    _.extend(HeaderView.prototype, {
      verifyShowSiteSearch: function (e) {
        // override to always show the site-search
        return this.$('[data-action="show-sitesearch"]').show();
      }
    });
  }
);
